import NextImage from "@/components/NextImage";
// import { validateImgSrc } from "@/utils/global";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import { IoIosArrowDown } from "react-icons/io";

const CompanyInformation = ({ active, onActiveAccordion, data }) => {
  const { locale } = useRouter();
  return (
    <div className="col-span-3 max-[1200px]:col-span-4 max-[768px]:col-span-8 2sm:px-2 2sm:rounded-md 2sm:bg-zinc-600">
      <div
        onClick={() => onActiveAccordion(active === "desc" ? null : "desc")}
        className="2sm:flex 2sm:items-center 2sm:justify-between"
      >
        <h2 className="mb-4 text-xl font-bold 2sm:my-2">
          {data?.about?.[`title-${locale}`]}
        </h2>
        <IoIosArrowDown
          size="24px"
          className={`hidden 2sm:block ${
            active === "desc" ? "rotate-180" : "rotate-0"
          }`}
        />
      </div>
      <p
        className={`text-justify text-sm leading-6 2sm:mb-2 ${
          active !== "desc" && "2sm:hidden"
        }`}
      >
        {data?.about?.[`description-${locale}`]}
        <br />
        {data?.about?.[`sr-number-${locale}`]}
      </p>
      <div
        className={`flex items-center gap-2 my-[1.5rem] ${
          active !== "desc" && "2sm:hidden"
        }`}
      >
        {data?.deeplinks?.map((link) => (
          <Link
            target="_blank"
            href={link?.url}
            className="relative overflow-hidden w-28 aspect-video"
            key={link?.img}
          >
            <NextImage
              src={link?.img} //validateImgSrc(link?.img)}
              className="object-contain w-[107px] h-[32px]"
              width={107}
              height={32}
              alt={link?.img}
            />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CompanyInformation;
